import { useEffect, useState } from "react";
import { useNavigate, useParams } from "react-router-dom";
import Seo from "../components/Seo";
import { api } from "../lib/api";
import { cartTotal, getCart, saveCart } from "../lib/cart";
import { Currency, formatMoney } from "../lib/currency";
import { t } from "../lib/i18n";

export default function Checkout({ currency }: { currency: Currency }) {
  const { lang = "en" } = useParams();
  const navigate = useNavigate();
  const [items] = useState(getCart());
  const [methods, setMethods] = useState<any[]>([]);
  const [form, setForm] = useState<any>({ name: "", email: "", phone: "", country: "", city: "", address: "", postal_code: "", note: "", payment_method_id: 1 });
  useEffect(() => { api<any[]>("/api/payment-methods").then(setMethods).catch(() => setMethods([])); }, []);
  async function submit() {
    const order = await api<{ order_no: string }>("/api/orders", { method: "POST", body: JSON.stringify({ ...form, currency, total: cartTotal(items), items: items.map((item) => ({ productId: item.productId, sku: item.sku, title: item.title, price: item.price, quantity: item.quantity })) }) });
    saveCart([]);
    navigate(`/${lang}/order-payment/${order.order_no}`);
  }
  const zh = lang === "zh";
  return (
    <>
      <Seo title={t(lang, "checkout")} description="Enter shipping details and choose a manual payment method for your SellerSupply Shop order." />
      <section className="container-page grid gap-6 py-8 md:grid-cols-[1fr_360px]">
        <form className="panel space-y-4 p-5" onSubmit={(e) => { e.preventDefault(); submit(); }}>
          <h1 className="text-2xl font-black">{t(lang, "checkout")}</h1>
          {[
            ["name", zh ? "姓名" : "Name"], ["email", zh ? "邮箱" : "Email"], ["phone", zh ? "电话" : "Phone"], ["country", zh ? "国家" : "Country"], ["city", zh ? "城市" : "City"], ["address", zh ? "地址" : "Address"], ["postal_code", zh ? "邮编" : "Postal code"]
          ].map(([key, label]) => <input key={key} className="input" placeholder={label} value={form[key]} onChange={(e) => setForm({ ...form, [key]: e.target.value })} />)}
          <textarea className="input rounded-[24px]" placeholder={zh ? "备注" : "Note"} value={form.note} onChange={(e) => setForm({ ...form, note: e.target.value })} />
          <select className="input" value={form.payment_method_id} onChange={(e) => setForm({ ...form, payment_method_id: Number(e.target.value) })}>{methods.map((m) => <option key={m.id} value={m.id}>{m.name}</option>)}{!methods.length ? <option value={1}>USDT TRC20</option> : null}</select>
          <button className="btn-primary w-full">{zh ? "提交订单" : "Submit order"}</button>
        </form>
        <aside className="panel h-fit p-5"><h2 className="font-bold">{zh ? "订单摘要" : "Order summary"}</h2>{items.map((item) => <div className="mt-3 flex justify-between text-sm" key={item.productId}><span>{item.title} x {item.quantity}</span><b>{formatMoney(item.price * item.quantity, currency)}</b></div>)}<p className="mt-5 text-2xl font-black">{formatMoney(cartTotal(items), currency)}</p></aside>
      </section>
    </>
  );
}
